import React from "react";
import { FormGroup, Label, FormFeedback, Input } from "reactstrap";
import DatePicker from "react-datepicker";

const DatePickerInput = ({
  name,
  label,
  error,
  row,
  bold,
  required,
  ...rest
}) => {
  const restProp = { ...rest };
  if (!restProp.autoComplete) {
    delete restProp.autoComplete;
  }
  const invalidClass = error ? " is-invalid" : "";
  return (
    <FormGroup row={row} className={required ? "required" : ""}>
      <Label
        xs={row && "auto"}
        for={name}
        className={bold ? "font-weight-bold" : ""}
      >
        {label}
      </Label>
      <DatePicker
        xs={row && "auto"}
        className={"form-control" + invalidClass}
        {...restProp}
        name={name}
        id={name}
      />
      <Input hidden invalid={error ? true : false} />
      <FormFeedback>{error}</FormFeedback>
    </FormGroup>
  );
};

export default DatePickerInput;
